"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHostsProperty = exports.hostsPropertyDefinition = void 0;
exports.hostsPropertyDefinition = {
    view: { label: 'Hosts' },
    constraints: [],
    type: 'text',
    multiple: true,
    name: 'hosts',
};
const isHostsProperty = (prop) => {
    return prop.name === exports.hostsPropertyDefinition.name;
};
exports.isHostsProperty = isHostsProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaG9zdHMucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9ob3N0cy5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLHVCQUF1QixHQUFHO0lBQ3JDLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxPQUFPLEVBQUU7SUFDeEIsV0FBVyxFQUFFLEVBQUU7SUFDZixJQUFJLEVBQUUsTUFBTTtJQUNaLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLE9BQU87Q0FDa0IsQ0FBQTtBQUkxQixNQUFNLGVBQWUsR0FBRyxDQUFDLElBQWtCLEVBQXlCLEVBQUU7SUFDM0UsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLCtCQUF1QixDQUFDLElBQUksQ0FBQTtBQUNuRCxDQUFDLENBQUE7QUFGWSxRQUFBLGVBQWUsbUJBRTNCIn0=